/**
 * Vérifier si le devis est expiré après six mois
 * @param {string|Date} dateToCheck - Date du devis
 * @returns {boolean} - Indique si le devis est expiré (true)
 */
export const isExpireOf6Month = (dateToCheck) => {
  if (!dateToCheck) return true; // Sécurité : pas de date = expiré

  const date = new Date(dateToCheck); // conversion explicite en objet Date
  const today = new Date();

  const sixMonthsLater = new Date(date);
  sixMonthsLater.setMonth(date.getMonth() + 6);

  return sixMonthsLater < today;
};
